(function () {
  var SECTION = document.currentScript.getAttribute("data-section");
  var PER_PAGE = 6;

  var wrapper = document.getElementById("Measurement-" + SECTION);
  if (!wrapper) return;

  var cards = Array.from(wrapper.querySelectorAll(".mg-card"));
  var loadBtn = document.getElementById("mg-load-btn-" + SECTION);
  var shown = 0;

  function showCards(from, count) {
    cards.slice(from, from + count).forEach(function (card, i) {
      setTimeout(function () {
        card.classList.add("visible");
      }, i * 70);
    });
    shown = from + count;
  }

  showCards(0, PER_PAGE);

  cards.slice(PER_PAGE).forEach(function (card) {
    card.style.display = "none";
  });

  if (loadBtn) {
    loadBtn.addEventListener("click", function () {
      var next = cards.slice(shown, shown + PER_PAGE);
      next.forEach(function (card) {
        card.style.display = "";
      });
      requestAnimationFrame(function () {
        showCards(shown, PER_PAGE);
        if (shown >= cards.length) {
          loadBtn.parentElement.style.display = "none";
        }
      });
    });
  }

  wrapper.addEventListener("click", function (e) {
    var card = e.target.closest(".mg-card.has-modal");
    if (!card) return;
    var modalId = card.getAttribute("data-modal");
    if (!modalId) return;
    openModal(document.getElementById(modalId));
  });

  document.addEventListener("click", function (e) {
    if (
      e.target.classList.contains("mg-modal-overlay") ||
      e.target.classList.contains("mg-modal") ||
      e.target.closest(".mg-modal-close")
    ) {
      var modal = e.target.closest(".mg-modal");
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var open = document.querySelector(".mg-modal.open");
      if (open) closeModal(open);
    }
  });

  function openModal(modal) {
    if (!modal) return;
    var iframe = modal.querySelector("iframe[data-src]");
    if (iframe) {
      iframe.src = iframe.getAttribute("data-src");
      iframe.removeAttribute("data-src");
    }
    var nativeVideo = modal.querySelector("video");
    if (nativeVideo) {
      nativeVideo.play();
    }
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeModal(modal) {
    modal.classList.remove("open");
    document.body.style.overflow = "";
    var iframe = modal.querySelector("iframe[src]");
    if (iframe) {
      var s = iframe.src;
      iframe.src = "";
      iframe.src = s;
    }
    var nativeVideo = modal.querySelector("video");
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.currentTime = 0;
    }
  }
})();
